module.exports = __webpack_public_path__ + "img/fossilImg1.535ef591.jpg";